import React from 'react';

export default function ({ loading, loadingText }) {
  return loading ? (
    <div className="dynamic-result-page--loader is-visible">
      <div className="dynamic-result-page--loader-content is-visible">
        <div className="dynamic-loader-cube">
          <div className="dynamic-cube1 dynamic-cube"></div>
          <div className="dynamic-cube2 dynamic-cube"></div>
          <div className="dynamic-cube4 dynamic-cube"></div>
          <div className="dynamic-cube3 dynamic-cube"></div>
        </div>
        <p>
          <strong>{loadingText ? loadingText : 'Loading'}</strong>
        </p>{' '}
        ​
      </div>
    </div>
  ) : null;
}
